import { render } from "./SeoulTradeStat10Year.vue?vue&type=template&id=6191e134&ts=true"
import script from "./SeoulTradeStat10Year.vue?vue&type=script&lang=ts"
export * from "./SeoulTradeStat10Year.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__